import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography, Button } from '@material-ui/core';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import { useIsDesktop, useTranslations } from 'components/utilities';

const Feature = ({ icon: Icon, name, price, selected, onChange }) => {
	const { t } = useTranslations();

	const ButtonIcon = selected
		? RemoveCircleOutlineOutlinedIcon
		: AddCircleOutlineOutlinedIcon;
	const buttonText = selected ? t('common.remove') : t('common.add');

	const isDesktop = useIsDesktop();

	return (
		<Box textAlign="center">
			<Box textAlign="center" pb={1}>
				<Icon fontSize="large" />
			</Box>

			<Typography variant={isDesktop ? 'h5' : 'h6'} gutterBottom>
				{name}
			</Typography>

			<Typography
				variant={isDesktop ? 'h5' : 'h6'}
				color="primary"
				gutterBottom
			>
				+{price}{' '}
				<Typography variant="h6" component="span">
					{t('common.sar')}
				</Typography>
			</Typography>

			{onChange && (
				<Button
					color="secondary"
					startIcon={<ButtonIcon fontSize={isDesktop ? 'large' : 'default'} />}
					size={isDesktop ? 'large' : 'medium'}
					onClick={onChange}
				>
					{buttonText}
				</Button>
			)}
		</Box>
	);
};

Feature.propTypes = {
	icon: PropTypes.elementType,
	name: PropTypes.string,
	price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selected: PropTypes.bool,
	onChange: PropTypes.func,
};

export default Feature;
